import { isTV, isWebkitEngine } from '@foundation-player/platform-check';
import { AutoplayDetection } from './autoplay-detection';
import { DefaultAutoplayDetection } from './default-autoplay-detection';
import { SafariAutoplayDetection } from './safari-autoplay-detection';
import { TVAutoplayDetection } from './tv-autoplay-detection';

/**
 * Returns a AutoplayDetection instance that is responsible for the respective platform.
 */
export function getAutoplayDetection(): AutoplayDetection {
  if (isTV()) {
    return new TVAutoplayDetection();
  } else if (isWebkitEngine()) {
    return new SafariAutoplayDetection(); // TODO: rename?
  } else {
    return new DefaultAutoplayDetection();
  }
}
